package com.eladfinish.bible.contest.ui.common

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider

@Composable
fun WithSystemButtonsConfiguration(
    onBackPressed: () -> Unit,
    content: @Composable () -> Unit,
) {
    val systemButtonsConfigurator = SystemButtonsConfigurator {
        onBackPressed()
    }

    CompositionLocalProvider(
        LocalSystemButtonsConfigurator provides systemButtonsConfigurator,
    ) {
        content()
    }
}
